(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  // HHC.FR — bug intermittent confirmé : le composant natif Horizon <overflow-list>
  // (assets/critical.js) mesure la largeur disponible du menu dès son initialisation
  // (requestIdleCallback), pour répartir les liens visibles / le bouton "Plus". Cette
  // mesure peut avoir lieu avant que les polices personnalisées (font-display: swap,
  // voir snippets/theme-styles-variables.liquid) aient fini de charger : le texte est
  // d'abord affiché avec une police de secours, puis substitué, ce qui change la
  // largeur des libellés ("NEW DROP", "VAPE & PUFF", etc.) sans changer la largeur du
  // conteneur lui-même — le ResizeObserver interne du composant ne détecte donc pas ce
  // changement, et le calcul initial (fait avec les mauvaises largeurs) reste figé :
  // presque tous les liens basculent dans "Plus", qui se retrouve seul visible.
  // Correctif ciblé, sans toucher au composant natif : une fois les polices chargées,
  // on redemande explicitement un recalcul via l'évènement "reflow", le point
  // d'extension prévu par le composant lui-même (voir #o() dans assets/critical.js).
  function requestMenuReflow() {
    document.querySelectorAll('#header-component overflow-list').forEach(function (list) {
      list.dispatchEvent(new CustomEvent('reflow', { detail: {} }));
    });
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(requestMenuReflow);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hhc-footer"] && !Shopify.designMode) return;
  try {
    
(function () {
  // HHC.FR — Chromium ne peint jamais le contenu d'un <details> fermé, même en forçant
  // "display" et "content-visibility" en CSS sur son contenu (essayé, confirmé cassé) :
  // seul l'attribut "open" réel pilote le rendu. Cette section doit rester une colonne
  // statique toujours visible sur desktop et un accordéon fermé par défaut sur mobile ;
  // sans JS, un seul balisage HTML ne peut pas satisfaire les deux à la fois. Ce script
  // synchronise donc l'attribut "open" sur le point de rupture desktop (min-width: 750px,
  // identique à la media query CSS ci-dessus), sans framework ni dépendance.
  var mql = window.matchMedia('(min-width: 750px)');

  function syncOpenState(e) {
    document.querySelectorAll('.hhc-footer__group').forEach(function (details) {
      if (e.matches) {
        details.setAttribute('open', '');
      } else {
        details.removeAttribute('open');
      }
    });
  }

  syncOpenState(mql);
  mql.addEventListener('change', syncOpenState);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
